import { useMediaQuery, useTheme } from '@mui/material';
import { OptionsObject } from 'notistack';

export type useSnackbarProperties = {
    severity?: 'default' | 'error' | 'success' | 'warning' | 'info' | 'SnackbarWithAction' | 'SnackbarLoader';
    duration?: number;
};

export const useSnackBarProps = (props: useSnackbarProperties): OptionsObject => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.only('xs'));
    const snackSize = isMobile ? '100%' : theme.spacing(40);
    const snackProps: OptionsObject = {
        variant: props.severity || 'error',
        autoHideDuration: props.duration || 6000,
        style: { paddingRight: '3rem', borderRadius: '1rem', width: snackSize }
    };
    return snackProps;
};
